import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApproval } from '../context/ApprovalContext';
import { Search } from 'lucide-react';

export default function ApprovalList() {
  const { approvals, fetchApprovals, APPROVAL_TYPES } = useApproval();
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');

  useEffect(() => { fetchApprovals(); }, [fetchApprovals]);

  const statusLabel = { pending:'대기중', approved:'승인', rejected:'반려', draft:'임시저장' };
  const filtered = approvals.filter(a => {
    const matchStatus = filter === 'all' || a.status === filter;
    const matchType = typeFilter === 'all' || a.type === typeFilter;
    const matchSearch = a.title.includes(search) || a.author.name.includes(search);
    return matchStatus && matchType && matchSearch;
  });

  return (
    <div className="page container">
      <div className="page-header">
        <h1 className="page-title">결재 목록</h1>
        <p className="page-subtitle">전체 결재 현황을 확인할 수 있습니다</p>
      </div>
      <div className="card" style={{marginBottom:16}}>
        <div style={{display:'flex', gap:10, flexWrap:'wrap', alignItems:'center'}}>
          <div style={{position:'relative', flex:1, minWidth:200}}>
            <Search size={15} style={{position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'#9ca3af'}} />
            <input className="form-input" style={{paddingLeft:34}} placeholder="제목, 작성자 검색..." value={search} onChange={e=>setSearch(e.target.value)} />
          </div>
          <select className="form-select" style={{width:130}} value={filter} onChange={e=>setFilter(e.target.value)}>
            <option value="all">전체 상태</option>
            <option value="pending">대기중</option>
            <option value="approved">승인</option>
            <option value="rejected">반려</option>
          </select>
          <select className="form-select" style={{width:150}} value={typeFilter} onChange={e=>setTypeFilter(e.target.value)}>
            <option value="all">전체 유형</option>
            {APPROVAL_TYPES.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
          </select>
        </div>
      </div>
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>유형</th><th>제목</th><th>기안자</th><th>결재자</th><th>상태</th><th>작성일</th><th>처리</th></tr>
            </thead>
            <tbody>
              {filtered.length === 0
                ? <tr><td colSpan={7} style={{textAlign:'center', color:'#9ca3af', padding:32}}>결재 내역이 없습니다</td></tr>
                : filtered.map(a => {
                  const typeInfo = APPROVAL_TYPES.find(t => t.id === a.type);
                  return (
                    <tr key={a.id} onClick={() => navigate(`/detail/${a.id}`)} style={{cursor:'pointer'}}>
                      <td><span style={{fontSize:18}}>{typeInfo?.icon}</span></td>
                      <td><span style={{fontWeight:500}}>{a.title}</span></td>
                      <td><span style={{fontSize:13}}>{a.author.name}<br/><span style={{color:'#9ca3af',fontSize:11}}>{a.author.dept}</span></span></td>
                      <td>
                        <div style={{display:'flex', gap:4}}>
                          {a.approvers.map((ap, i) => (
                            <div key={i} className="avatar" style={{width:28,height:28,fontSize:11,
                              background:ap.status==='approved'?'#10b981':ap.status==='rejected'?'#ef4444':'#d1d5db',color:'#fff'}}>
                              {ap.name[0]}
                            </div>
                          ))}
                        </div>
                      </td>
                      <td><span className={`badge badge-${a.status}`}>{statusLabel[a.status]}</span></td>
                      <td style={{fontSize:13, color:'#6b7280'}}>{a.createdAt}</td>
                      <td onClick={e=>e.stopPropagation()}>
                        <button className="btn btn-secondary btn-sm" onClick={()=>navigate(`/detail/${a.id}`)}>상세보기</button>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
